import styled from "styled-components";
import { borderRadius } from "../../utils/border-radius.es.js";
const BORDER_RADIUS_SIZE_VALUES = {
  none: 0,
  small: 2,
  large: 4
};
const ContainerOuter = styled("div")(
  {
    alignItems: "stretch",
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    height: "100%",
    transform: "translateZ(0)",
    width: "100%"
  },
  ({ $borderRadiusPlacement, $borderRadiusSize }) => borderRadius(
    $borderRadiusPlacement,
    BORDER_RADIUS_SIZE_VALUES[$borderRadiusSize]
  ),
  ({ $shadow }) => $shadow ? {
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)"
  } : void 0
);
const ContainerInner = styled("div")(
  {
    display: "flex",
    flex: "1 1 auto",
    overflow: "auto"
  },
  ({ $withFooter }) => !$withFooter ? borderRadius("bottom", "inherit") : void 0,
  ({ $withHeader }) => !$withHeader ? borderRadius("top", "inherit") : void 0,
  ({ $direction }) => $direction === "vertical" ? {
    flexDirection: "column"
  } : {
    flexDirection: "row"
  }
);
export {
  ContainerInner,
  ContainerOuter
};
